import en from './translations/en.json'
import ro from './translations/ro.json'

export default {
    en, ro
}
